import { useQuery, gql, TypedDocumentNode } from '@apollo/client';
import React from 'react';
import { PAGE_FILTER_FRAGMENT } from '../../components/PageFilter';
import { PRODUCT_LIST_PAGE_RESULT_FRAGMENT, ProductListing } from '../../components/ProductListing';
import { EmployeePageQuery, EmployeePageQueryVariables } from '../../generated/types';
import { usePLPParams } from '../../hooks/usePLPParams';
import { NotFoundPage } from '../NotFoundPage';
import { useUser } from '../../hooks/useUser';

export const EMPLOYEE_QUERY: TypedDocumentNode<EmployeePageQuery, EmployeePageQueryVariables> = gql`
  query EmployeePageQuery(
    $after: String!
    $attributes: [String]
    $availability: [AvailabilityInput]
    $categoryPath: String
    $countryCode: String
    $designers: [String]
    $dynamicReRanking: Boolean
    $filterColors: [String]
    $materials: [String]
    $onSale: Boolean
    $priceRange: PriceRange
    $markdownPercentages: [String]
    $scoring: String
    $sizes: [String]
  ) {
    employeeResult: employee(
      input: {
        attributes: $attributes
        availability: $availability
        category_path: $categoryPath
        country_code: $countryCode
        designers: $designers
        dynamic_reranking: $dynamicReRanking
        filter_colors: $filterColors
        materials: $materials
        on_sale: $onSale
        price_range: $priceRange
        rounded_markdown_percentages: $markdownPercentages
        scoring: $scoring
        sizes: $sizes
      }
    ) {
      ...ProductListPageResultFragment
      ...PageFilterFragment
    }
  }
  ${PRODUCT_LIST_PAGE_RESULT_FRAGMENT}
  ${PAGE_FILTER_FRAGMENT}
`;

export const EmployeePage: React.FC = () => {
  const { queryVariables } = usePLPParams();

  const { isEmployee } = useUser();

  const {
    data: currentData,
    previousData,
    error,
    loading
  } = useQuery(EMPLOYEE_QUERY, {
    variables: queryVariables
  });

  const data = currentData ?? previousData;

  const headerText = 'Internal Use Only';

  if ((data && !data.employeeResult) || !isEmployee) return <NotFoundPage />;

  return (
    <ProductListing
      title={headerText}
      headerText={headerText}
      queryResult={data?.employeeResult}
      error={error}
      loading={loading}
    />
  );
};
